import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatmodelsService {


  url = environment.serverAPI9 + "/api/models/verify";

  url1 = environment.serverAPI9 + "/api/chat-providers";

  url2 = environment.serverAPI11 + "/api/chat-providers";

  constructor(private http: HttpClient) { }

  verifykeys(payload: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, payload);
  }

  saveChatModel(payload: any): Observable<any> {
    if (payload.providerId) {
      return this.http.put<any>(`${this.url1}/${payload.providerId}`, payload).pipe(
        switchMap((res1: any) => {
          return this.http.put<any>(`${this.url2}/${payload.providerId}`, payload).pipe(
            catchError(err => {
              console.warn('Failed to update provider on secondary serverAPI11:', err);
              return of(null);
            }),
            map(() => res1)
          );
        })
      );
    } else {
      return this.http.post<any>(`${this.url1}`, payload).pipe(
        switchMap((res1: any) => {
          const createdProvider = res1?.data || res1;
          const providerId = createdProvider?.providerId;
          if (providerId) {
            const payloadWithId = { ...payload, providerId };
            return this.http.post<any>(`${this.url2}`, payloadWithId).pipe(
              catchError(err => {
                console.warn('Failed to create provider on secondary serverAPI11:', err);
                return of(null);
              }),
              map(() => res1)
            );
          }
          return of(res1);
        })
      );
    }
  }

  getProvidersDropdown(): Observable<any> {
    return this.http.get<any>(`${this.url1}/dropdown`);
  }

  deleteProvider(id: number): Observable<any> {
    return this.http.delete<any>(`${this.url1}/${id}`).pipe(
      switchMap((res1: any) => {
        return this.http.delete<any>(`${this.url2}/${id}`).pipe(
          catchError(err => {
            console.warn('Failed to delete provider from secondary serverAPI11:', err);
            return of(null);
          }),
          map(() => res1)
        );
      })
    );
  }

  /**
   * Calls the backend AI proxy endpoint.
   * The backend decrypts the stored API key and forwards the prompt to the
   * configured AI provider (e.g. OpenRouter). The real API key never leaves the server.
   *
   * @param prompt    The full prompt string to send to the AI model.
   * @param providerId Optional provider ID; if omitted, backend uses the first available provider.
   */
  aiEnhance(prompt: string, providerData: any): Observable<any> {
    const body: any = { 
      prompt, 
      ...providerData,
      provider_id: providerData?.providerId,
      api_url: providerData?.apiUrl,
      model: providerData?.models || providerData?.modelName,
      modelName: providerData?.models || providerData?.modelName
    };
    return this.http.post<any>(`${this.url1}/ai-enhance`, body);
  }

}
